import { createSelector } from 'reselect';
import { sportCompetitionsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const sportCompetitionsYearsSelector = createSelector([sportCompetitionsSelector], (sportCompetitions) =>
  extractDatesFromNestedItems(
    [sportCompetitions.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
